import { render, staticRenderFns } from "./GeodirMapDeliveryShao.vue?vue&type=template&id=5c5b764b"
import script from "./GeodirMapDeliveryShao.vue?vue&type=script&lang=js"
export * from "./GeodirMapDeliveryShao.vue?vue&type=script&lang=js"
import style0 from "./GeodirMapDeliveryShao.vue?vue&type=style&index=0&id=5c5b764b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports